import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { CircularProgress } from '@mui/material';
import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

import {
  useAgreeStoreDelegate,
  useStoreDelegateLink,
} from '../../../../shared/hooks/linkHook';
import {
  BlueRoundedButtonWithIcon,
  ButtonContainer,
} from '../../common/components/BlueRoundedButton';
import { Spacer } from '../../common/components/Spacer';
import { PreviewLayout } from '../Layout/PreviewLayout';
import {
  LinkPageBackground,
  LinkPageContainer,
  MessageComponent,
  MessageContent,
} from '../Preview/MessageComponents';

export const StoreDelegateAgreement = () => {
  const { id: uri = '' } = useParams();

  const {
    error: errorStoreDelegateLink,
    isSuccess: isLinkExist,
    isPending: isPendingLink,
  } = useStoreDelegateLink(uri);
  const isNotFound = errorStoreDelegateLink?.response?.status === 404;

  const {
    mutate: agreeStoreDelegate,
    isPending: isPendingAgree,
    isSuccess,
    error: errorAgreeStoreDelegate,
  } = useAgreeStoreDelegate();
  const isAlreadyHandled = errorAgreeStoreDelegate?.response?.status === 404;

  useLayoutEffect(() => {
    if (isLinkExist) {
      agreeStoreDelegate({ uri });
    }
  }, [agreeStoreDelegate, uri, isLinkExist]);

  return (
    <PreviewLayout>
      <LinkPageBackground>
        <LinkPageContainer>
          {isPendingLink || isPendingAgree ? (
            <CircularProgress size={60} />
          ) : isNotFound ? (
            <LinkNotFoundMessage />
          ) : isSuccess || isAlreadyHandled ? (
            <SuccessMessage />
          ) : (
            <LinkErrorMessage />
          )}
        </LinkPageContainer>
      </LinkPageBackground>
    </PreviewLayout>
  );
};

const LinkNotFoundMessage = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.storeDelegate.notFoundMessage',
  });

  return (
    <MessageComponent
      icon={<WarningAmberIcon sx={{ color: '#2e5be0', fontSize: '40px' }} />}
      title={t('title')}>
      <MessageContent>{t('content')}</MessageContent>
    </MessageComponent>
  );
};

const LinkErrorMessage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.storeDelegate.errorMessage',
  });

  return (
    <MessageComponent
      icon={<WarningAmberIcon sx={{ color: '#2e5be0', fontSize: '40px' }} />}
      title={t('title')}>
      <MessageContent>{t('content')}</MessageContent>
      <Spacer height={40} />
      <ButtonContainer>
        <BlueRoundedButtonWithIcon onClick={() => navigate('/send-images')}>
          {t('button')}
        </BlueRoundedButtonWithIcon>
      </ButtonContainer>
    </MessageComponent>
  );
};

export const SuccessMessage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.storeDelegate.agreementSuccess',
  });

  return (
    <MessageComponent
      icon={<WarningAmberIcon sx={{ color: '#2e5be0', fontSize: '40px' }} />}
      title={t('title')}>
      <MessageContent>{t('content')}</MessageContent>
      <Spacer height={40} />
      <ButtonContainer>
        <BlueRoundedButtonWithIcon onClick={() => navigate('/uploaded-images')}>
          {t('button')}
        </BlueRoundedButtonWithIcon>
      </ButtonContainer>
    </MessageComponent>
  );
};
